module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    class: ['op--modal-container', {
      hide: !_vm.show
    }]
  }, [_c('div', {
    staticClass: "op--modal"
  }, [_c('div', {
    staticClass: "op--modal-content"
  }, [_c('div', {
    staticClass: "content-box"
  }, [_c('div', {
    staticClass: "rt-msg"
  }, [_vm._v("\n            Great Move, Your Round trip fare for Flight From\n            "), _c('b', [_vm._v("\n              " + _vm._s(_vm.location.pickup.code) + " - " + _vm._s(_vm.location.dropoff.code) + "\n              "), (_vm.currency.code === 'USD') ? _c('span', [_vm._v("$" + _vm._s(parseFloat(_vm.totalPrice.toFixed(2))))]) : _c('span', [_vm._v(_vm._s(_vm.applyCurrency(_vm.totalPrice)))])])]), _vm._v(" "), _c('div', {
    staticClass: "field-row d-flex flex-column btn-box"
  }, [_c('a', {
    staticClass: "op-btn btn-block btn-md btn-success search-submit",
    on: {
      "click": _vm.proceed
    }
  }, [_vm._v("\n              Proceed for Booking\n            ")]), _vm._v(" "), _c('a', {
    staticClass: "op-btn btn-block btn-md",
    on: {
      "click": function($event) {
        _vm.show = false
      }
    }
  }, [_vm._v("\n              I change my mind\n            ")])])])])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-372ae9be", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-372ae9be","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/D2DService/confirm-rt-modal.vue
// module id = 2068
// module chunks = 0